import axiosInstance from "./axiosInstance";
import Configs from "../utils/Configs";

const ProfileDeletePhotoApi = {
  deletePhoto: async (photoId) => {
    try {
      const response = await axiosInstance.post(Configs.deletePhotoEp, {
        photo_id: photoId,
      });

      if (response.status === 200) {
        return response.data || {};
      } else {
        console.error("Failed to delete photo");
        return {
          status: "fail",
          data: "Unexpected server response",
        };
      }
    } catch (error) {
      console.error("Error deleting photo:", error);
      return {
        status: "fail",
        data: error?.response?.data || error.message || "Delete failed",
      };
    }
  },
};

export default ProfileDeletePhotoApi;
